import { useNavigate } from "react-router-dom";
import { getRatingClasses } from "../util/ratings";

export const TVShowListItemCard = ({ tvShowListItem }) => {
  const navigate = useNavigate();
  const handleClick = () =>
    navigate(`/tvshows/${tvShowListItem?.listSid}/${tvShowListItem?.sid}`, {
      state: { tvShowListItem },
    });

  return (
    <li
      onClick={handleClick}
      className="card p-4 cursor-pointer hover:border-teal-600"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="font-medium text-stone-800 truncate">
            {tvShowListItem?.tvShow?.title}
          </div>
          <div className="text-sm text-stone-500">
            {tvShowListItem?.dateStarted}
          </div>
        </div>
        <span
          className={`badge shrink-0 ${getRatingClasses(tvShowListItem?.rating)}`}
        >
          {tvShowListItem?.rating?.description}
        </span>
      </div>
    </li>
  );
};

const TVShowListItemRow = ({ tvShowListItem }) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/tvshows/${tvShowListItem?.listSid}/${tvShowListItem?.sid}`, {
      state: { tvShowListItem },
    });
  };

  return (
    <tr onClick={handleRowClick} className="cursor-pointer hover:bg-stone-100">
      <td className="px-3 py-2">{tvShowListItem?.tvShow?.title}</td>
      <td className="px-3 py-2">{tvShowListItem?.dateStarted}</td>
      <td className="px-3 py-2">
        <span className={`badge ${getRatingClasses(tvShowListItem?.rating)}`}>
          {tvShowListItem?.rating?.description}
        </span>
      </td>
    </tr>
  );
};

export default TVShowListItemRow;
